<template>
  <div id="template-confirmation-view">
    <BookingSummary title="You're Going to Orlando!" step="confirmation" />
  </div>
</template>

<script>
import BookingSummary from './BookingSummary.vue';

export default {
  components: {
    BookingSummary
  },
  beforeCreate() {
    let hasListing = Object.keys(this.$store.state).includes('listing')
    let hasStateReservation = (
      Object.keys(this.$store.state).includes('reservation') &&
      typeof this.$store.state.reservation !== 'undefined'
    )
    let hasAppReservation = (
      Object.keys(this.$store.state.app_data).includes('reservation') &&
      typeof this.$store.state.app_data.reservation !== 'undefined'
    )
    if (
      !hasListing ||
      (
        hasStateReservation &&
        hasAppReservation &&
        this.$store.state.reservation.confirmation_id != this.$store.state.app_data.reservation.confirmation_id
      )
    ) {
      let { dates, breakdown, listing, reservation } = this.$store.state.app_data
      this.$store.commit('initializeConfirmation', {
        reservation: reservation,
        dates: dates,
        breakdown: breakdown,
        listing: listing
      })
    }
  }
}
</script>

<style>
@media print {
  .booking-summary {
    background: $bgGray;
    z-index: 2;

    &__details {
      padding: 20px 28px;
    }

    h1 {
      position: absolute;
      bottom: 15px;
      left: 28px;
      font-size: 56px;
      font-weight: 300;
      color: $white;
    }

    h5 {
      font-size: 16px;
      line-height: 1.38;
      letter-spacing: 0.25px;
      color: $gray;
      margin: 0 0 20px 0;
    }

    h3 {
      margin: 0 0 10px 0;
    }

    .btn {
      font-size: 20px;
      line-height: 1.3;
      letter-spacing: 0.14px;
      text-align: center;
      color: $white;
      background: $blueWhale;
      width: 100%;
      margin: 20px 0;
      white-space: nowrap;
    }

    .listing-image {
      position: relative;
      display: flex;
      align-items: flex-start;
      &__scrim {
        position: absolute;
        opacity: 0.4;
        background: $black;
        width: 100%;
        height: 100%;
      }
    }

    .summary-attributes,
    .attribute-container {
      display: flex;
    }

    .summary-attributes {
      margin: 20px 0;
    }

    .attribute-container {
      height: 22px;
      margin: 0 20px 0 0;
      line-height: 22px;
      width: 40px;
    }

    .attribute-value {
      font-size: 16px;
      color: $gray;
      margin: 0 0 0 7px;
    }

    .dates {
      display: flex;
      flex-flow: column wrap;
      &__date {
        font-size: 16px;
        line-height: 1.63;
        letter-spacing: 0.11px;
        display: flex;
        justify-content: space-between;
        padding: 15px 0;
        border-bottom: 2px solid $accent;

        &:last-child {
          border-bottom: 0;
        }
      }

      &__title {
        color: $gray;
      }

      &__value {
        color: $blueWhale;
      }
    }

    .detailed-totals {
      display: none;
      &.inline {
        display: block;

        &.expanded {
          border-top: 2px solid $accent;
        }
      }
    }

    .breadcrumb {
      display: none;
    }

    .create-account-section {
      padding: 30px 0 10px;
      p {
        text-align: center;
      }
    }

    .confirmation-links {
      text-align: center;
      &__link {
        width: 100%;
        padding: 20px 0;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $blueWhale;
        i {
          margin: 0 10px;
        }
        svg {
          width: 27px;
          path {
            fill: $blueWhale;
          }
        }
      }
    }

    @mixin breakpoint $tablet {
      position: sticky;
      top: 80px;

      &__box {
        display: flex;
        flex-flow: row-reverse;
      }

      &__details {
        width: 50%;
        flex-shrink: 0;
        padding: 40px 50px 30px;
      }

      .listing-image {
        h1 {
          display: none;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .detailed-totals {
        display: block;

        &.inline {
          display: none;
        }

        &.expanded {
          padding: 30px 0;
        }

        .dates {
          &__date {
            margin: 0 50px;
          }
        }
      }
    }

    @mixin breakpoint $desktop {
      flex-basis: 25%;
      min-width: 390px;
      height: calc(100vh - 80px);
      overflow-y: scroll;

      &__details {
        width: 100%;
      }

      &__box {
        flex-flow: column;
      }
      .detailed-totals {
        display: none;

        &.inline {
          display: block;
        }

        &.expanded {
          padding: 0;
        }

        .dates {
          &__date {
            margin: 0;
          }
        }
      }

      .confirmation-links {
        &__group {
          display: flex;
          padding: 0 60px;
          width: 45%;
        }

        &__link {
          padding: 0 16px;
        }
      }
    }
  }

  #template-confirmation-view {
    .booking-summary {
      @mixin breakpoint $tablet {
        &__details {
          width: 100%;
        }
        &__box {
          flex-flow: column;
        }

        .detailed-totals {
          display: none;
          &.inline {
            display: block;
          }

          &.expanded {
            padding: 0;
          }

          .dates__date {
            margin: 0;
          }
        }
      }
      @mixin breakpoint $desktop {
        height: calc(100vh - 160px);

        &__details {
          width: 25%;
          height: 100%;
          overflow-y: scroll;
        }

        &__box {
          flex-flow: row;
          height: 100%;
        }

        .listing-image {
          width: 75%;
          h1 {
            display: block;
            bottom: initial;
            top: 60px;
            left: 60px;
          }
        }

        .breadcrumb {
          display: block;
          position: absolute;
          top: 30px;
          left: 60px;
          &, a {
            color: white;
          }
        }

        .confirmation-links {
          position: fixed;
          bottom: 0;
          width: 100%;
          left: 0;
          height: 80px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
